import {  useState } from 'react';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../assets/img/fondo-diseno.jpg';


function Forgot() {  
const navigate = useNavigate();
const[user,setUser]=useState('')
const getpassword = async () => {
console.log(user)
if(!user){
    window.alert("Enter email")
    return
}
const data = await fetch(`https://msensorapi.coolproyectdata.online/newmail.php?from=${user}`, {
method: "POST",
mode:"no-cors",
headers: {
Accept: "application/json",
'Content-Type': 'application/json',
},
})
// .then((response) => response.json())
// .then((responseData) => {
console.log(data,"Result")
navigate("/")
//  


// })
}




return(
    <div
    style={{ backgroundImage: `url(${backgroundImage})` }}
    className="u-body u-xl-mode"
    data-lang="en"
  >
    <section className="u-section-1" id="sec-5b86">
      <div className="u-clearfix u-sheet u-sheet-1">
        <div
          style={{
            backgroundColor: "rgba(102, 16, 242, 0.0)",
          }}
          className="u-align-center u-container-style u-expanded-width-xs u-grey-90 u-group u-radius-5 u-shape-round u-group-1"
        >
          <div
            style={{
              backgroundColor: "rgba(102, 16, 242, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
              padding: "20px",
            }}
            className="u-container-layout u-valign-top-lg u-valign-top-md u-valign-top-sm u-valign-top-xl u-container-layout-1"
          >
            {/* Logo Section */}
            <div
              style={{
                backgroundColor: "rgba(62, 16, 242, 0.5)",
                width: "170px",
                height: "140px",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                border: "3px solid rgba(120, 150, 202, 0.8)",
                borderRadius: "7px",
              }}
            >
              <img
                alt=""
                src={require("../assets/img/logo.png")}
                style={{
                  width: "160px",
                  alignSelf: "center",
                  verticalAlign: "center",
                }}
              />
            </div>

         
        
              <div className="u-form u-login-control " style={{ width: "100%", maxWidth: "400px" }}>
              <div style={{color:"#fff",fontWeight:"700",fontSize:"35px",}}>FORGOT PASSWORD</div>
              <div className="u-form-group u-form-name u-label-top mt-3">
                <img
                  alt=""
                  src={require("../assets/img/user.png")}
                  style={{
                    width: "37px",
                    alignSelf: "center",
                    verticalAlign: "center",
                  }}
                />Email
       <input
                    type="text"
                    placeholder="Enter your Email"
                    id="username-a30d"
                    name="email"
                    className="u-border-8 u-border-white mt-1 u-input u-input-rectangle u-radius-4 u-white u-input-2"
onChange={(e)=>setUser(e.target.value)}   required=""
style={{ width: "100%" }}/>
</div>

<div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "15%",
                  }}
                  className="u-align-center u-form-group u-form-submit u-label-top"
                >
                  <button
                    onClick={() => getpassword()}
                    className="u-border-none mt-3   u-radius-4  "
                    style={{
                      border: "none",
                      width: "30%",
                      fontWeight: "700",
                      height: "50px",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                      backgroundColor: "#007bff",
                      padding: "0px",
                    }}
                  >
                    Send
                  </button>
                 
                </div>


</div>
</div>
</div>
</div>


</section>
</div>
)
}

export default Forgot;